import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM11 16a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1M12 19a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.555 3.168A1 1 0 0 0 6 4v24a1 1 0 0 0 1.555.832L10 27.202l2.445 1.63a1 1 0 0 0 1.11 0L16 27.202l2.445 1.63a1 1 0 0 0 1.11 0L22 27.202l2.445 1.63A1 1 0 0 0 26 28V4a1 1 0 0 0-1.555-.832L22 4.798l-2.445-1.63a1 1 0 0 0-1.11 0L16 4.798l-2.445-1.63a1 1 0 0 0-1.11 0L10 4.798zM8 26.131V5.87l1.445.963a1 1 0 0 0 1.11 0L13 5.202l2.445 1.63a1 1 0 0 0 1.11 0L19 5.202l2.445 1.63a1 1 0 0 0 1.11 0L24 5.869v20.263l-1.445-.964a1 1 0 0 0-1.11 0L19 26.798l-2.445-1.63a1 1 0 0 0-1.11 0L13 26.798l-2.445-1.63a1 1 0 0 0-1.11 0z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconReceipts = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconReceipts);
export default Memo;
